import { useSyncExternalStore } from 'react'

type ReviewEntryRequest = Readonly<{
  navigationKey: string
  paidLearning?: boolean
  complete: (allowed: boolean) => void
}>
let current: ReviewEntryRequest | null = null
let pending: Promise<boolean> | null = null
const listeners = new Set<() => void>()
const notify = () => listeners.forEach((listener) => listener())

// Coalesce repeated effects/clicks while one entry decision is in progress.
export function requestScheduledReviewEntry(
  navigationKey: string,
  paidLearning?: boolean,
): Promise<boolean> {
  if (pending && current?.navigationKey === navigationKey) return pending
  if (current) finishScheduledReviewEntry(false)
  pending = new Promise<boolean>((resolve) => {
    current = {
      navigationKey,
      complete: resolve,
      ...(paidLearning === undefined ? {} : { paidLearning }),
    }
  })
  notify()
  return pending
}

export function finishScheduledReviewEntry(
  allowed: boolean,
  expectedRequest?: ReviewEntryRequest,
) {
  if (expectedRequest && current !== expectedRequest) return false
  const previous = current
  current = null
  pending = null
  notify()
  previous?.complete(allowed)
  return true
}

export function useScheduledReviewEntryRequest() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
      }
    },
    () => current,
    () => null,
  )
}
